export const PRODUCTION_DEMO_HOSTS = ['rhythmbot.jpbouvetmethod.com', 'www.rhythmbot.jpbouvetmethod.com']
export const PRODUCTION_HOSTS = [...PRODUCTION_DEMO_HOSTS, 'rhythmbot.app', 'www.rhythmbot.app']
